import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = ["href"]

import { computed } from 'vue'
import type { Currency } from '@/types'
import Typography from '@/components_new/Typography.vue'
import AmazonLogo from './images/amazon_logo.svg'
import RobloxLogo from './images/roblox_logo.svg'

type RewardCardProps = {
    type: 'roblox' | 'amazon'
    value: number
    currency: Currency
}

export default /*@__PURE__*/_defineComponent({
  __name: 'RewardCard',
  props: {
    type: {},
    value: {},
    currency: {}
  },
  setup(__props: any) {

const props = __props

const logo: Record<RewardCardProps['type'], string> = {
    roblox: RobloxLogo,
    amazon: AmazonLogo,
}

const currencySign = computed(() => {
    if (props.currency === 'eur') {
        return '€'
    }
    return '$'
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.$style.card, _ctx.$style[props.type]])
  }, [
    (_openBlock(), _createElementBlock("svg", {
      class: _normalizeClass(_ctx.$style.svg),
      viewBox: "0 0 100 100"
    }, [
      (props.type === 'roblox')
        ? (_openBlock(), _createElementBlock("image", {
            key: 0,
            href: logo[props.type],
            x: "10",
            y: "10",
            width: "90",
            height: "20"
          }, null, 8, _hoisted_1))
        : (props.type === 'amazon')
          ? (_openBlock(), _createElementBlock("image", {
              key: 1,
              href: logo[props.type],
              x: "10",
              y: "10",
              width: "70",
              height: "30"
            }, null, 8, _hoisted_2))
          : _createCommentVNode("", true),
      _createVNode(Typography, {
        is: "text",
        class: _normalizeClass(_ctx.$style.value),
        accent: "",
        x: "8",
        y: "94",
        "font-size": "20",
        "dominant-baseline": "text-after-edge"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(currencySign.value) + _toDisplayString(props.value), 1)
        ]),
        _: 1
      }, 8, ["class"])
    ], 2))
  ], 2))
}
}

})